import { type DisplayTextItems } from '../types';
import { DisplayTextViewItem, Space } from './DisplayTextItem';
export const SubjectTextDisplay = ({
  displayItems
}: {
  displayItems: DisplayTextItems;
}) => {
  const {
    subject,
    subSubject
  } = displayItems;
  if (subSubject?.value && subSubject.value !== 'none') {
    return <>
        <Space />
        <DisplayTextViewItem item={subSubject} />
      </>;
  }
  return <>
      <Space data-sentry-element="Space" data-sentry-source-file="SubjectTextDisplay.tsx" />
      <DisplayTextViewItem item={subject} data-sentry-element="DisplayTextViewItem" data-sentry-source-file="SubjectTextDisplay.tsx" />
    </>;
};